(() => {
  'use strict';
  const labels = JSON.parse(document.getElementById('atlas-media-labels')?.textContent || '{}');
  const initialize = () => {
    document.querySelectorAll('[data-story-film]:not([data-ready])').forEach(frame => {
      frame.dataset.ready = 'true';
      const video = frame.querySelector('video'), controls = frame.querySelector('.story-film-controls');
      const play = frame.querySelector('[data-film-play]'), sound = frame.querySelector('[data-film-sound]');
      let userPaused = false, inView = false;
      video.muted = true; video.controls = false; controls.hidden = false;
      const icon = (button, name, label) => {
        button.innerHTML = '<i data-lucide="' + name + '" aria-hidden="true"></i>';
        button.setAttribute('aria-label', label); button.title = label;
        window.lucide?.createIcons();
      };
      const load = () => { if (!video.getAttribute('src') && !video.querySelector('source') && video.dataset.filmSrc) { video.src = video.dataset.filmSrc; video.load(); } };
      const start = () => { load(); return video.play().catch(() => {}); };
      const sync = () => icon(play, video.paused ? 'play' : 'pause', video.paused ? labels.play : labels.pause);
      video.addEventListener('play', sync); video.addEventListener('pause', sync);
      play.addEventListener('click', () => {
        if (video.paused) { userPaused = false; start(); } else { userPaused = true; video.pause(); }
      });
      sound.addEventListener('click', () => {
        video.muted = !video.muted;
        sound.setAttribute('aria-pressed', String(!video.muted));
        icon(sound, video.muted ? 'volume-x' : 'volume-2', video.muted ? labels.unmute : labels.mute);
        if (video.paused) { userPaused = false; start(); }
      });
      const reduced = matchMedia('(prefers-reduced-motion:reduce)');
      if ('IntersectionObserver' in window) {
        const loader = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { load(); loader.disconnect(); }
        }, {rootMargin:'200px'});
        loader.observe(frame);
        const observer = new IntersectionObserver(entries => {
          inView = entries[0].isIntersecting;
          if (inView && !reduced.matches && !userPaused && !document.hidden) start(); else video.pause();
        }, {threshold:.15});
        observer.observe(frame);
      }
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause(); else if (inView && !reduced.matches && !userPaused) start();
      });
      reduced.addEventListener('change', () => { if (reduced.matches) video.pause(); });
    });
  };
  initialize(); document.addEventListener('shopify:section:load', initialize);
  const chat = document.querySelector('[data-whatsapp]');
  if (!chat) return;
  const panel = chat.querySelector('.atlas-chat-panel'), toggle = chat.querySelector('[data-chat-toggle]');
  const close = focus => { panel.hidden = true; toggle.setAttribute('aria-expanded', 'false'); if (focus) toggle.focus(); };
  toggle.addEventListener('click', event => {
    event.preventDefault();
    if (!panel.hidden) return close(false);
    panel.hidden = false; toggle.setAttribute('aria-expanded', 'true'); panel.querySelector('a')?.focus();
  });
  chat.querySelector('[data-chat-close]').addEventListener('click', () => close(true));
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && !panel.hidden) close(true); });
  document.addEventListener('click', event => { if (!chat.contains(event.target)) close(false); });
})();
